<div class="container">
  <ul class="progressbar">
    <li
      [ngClass]="{ active: currentStep >= 1 && !isDetailsView, 'inactive disabled': currentStep <= 0 || isDetailsView }"
      id="location-update"
      tabindex="0">
      <i
        class="icon-location header-icon"
        [ngClass]="{ 'active-header-icon': currentStep >= 1 && !isDetailsView }"
        (click)="router.navigateByUrl('/jurisdiction')"></i>
      <div class="location-text-box">{{ 'basic-profile.jurisdiction.juri_check' | translate }}</div>
    </li>

    <ng-container *ngIf="!showTechnicalFormFirst">
      <li [ngClass]="{ active: currentStep >= 2, 'inactive disabled': currentStep <= 1 }" id="personal-data-0" tabindex="0">
        <i class="icon-info header-icon" [ngClass]="{ 'active-header-icon': currentStep >= 2 }" (click)="navigate('personal-data')"></i>
        <div class="location-text-box">{{ 'basic-profile.jurisdiction.perData' | translate }}</div>
      </li>
      <li [ngClass]="{ active: currentStep >= 3, 'inactive disabled': currentStep <= 2 }" id="tech-data-0" tabindex="0">
        <i class="header-icon" [ngClass]="{ 'active-header-icon': currentStep >= 3 }" (click)="navigate('facilities')">
          <span class="icon-technical_data1"></span>
          <span class="icon-technical_data2"></span>
          <span class="icon-technical_data3"></span>
        </i>
        <div class="location-text-box">{{ 'app.navigation.tech_data' | translate | uppercase }}</div>
      </li>
    </ng-container>

    <ng-container *ngIf="showTechnicalFormFirst">
      <li [ngClass]="{ active: currentStep >= 2, 'inactive disabled': currentStep <= 1 }" id="tech-data-1" tabindex="0">
        <i class="header-icon" [ngClass]="{ 'active-header-icon': currentStep >= 2 }" (click)="navigate('technical-data')">
          <span class="icon-technical_data1"></span>
          <span class="icon-technical_data2"></span>
          <span class="icon-technical_data3"></span>
        </i>
        <div class="location-text-box">{{ 'app.navigation.tech_data' | translate | uppercase }}</div>
      </li>
      <li
        *ngIf="showRegulatoryData"
        [ngClass]="{ active: currentStep >= 4 || isDetailsView, 'inactive disabled': currentStep <= 3 && !isDetailsView }"
        id="regulatory-data"
        tabindex="0">
        <i
          class="pi pi-briefcase header-icon"
          [ngClass]="{ 'active-header-icon': currentStep >= 4 || isDetailsView }"
          (click)="navigate('regulatory-data')"></i>
        <div class="location-text-box">{{ 'app.navigation.regulatory-data' | translate | uppercase }}</div>
      </li>
      <li
        [ngClass]="{ active: isDetailsView || currentStep >= 3, 'inactive disabled': currentStep <= 2 && !isDetailsView }"
        id="personal-data-1"
        tabindex="0">
        <i
          class="icon-info header-icon"
          [ngClass]="{ 'active-header-icon': isDetailsView || currentStep >= 3 }"
          (click)="navigate('personal-data')"></i>
        <div class="location-text-box">{{ 'basic-profile.jurisdiction.perData' | translate }}</div>
      </li>
    </ng-container>

    <li
      [ngClass]="{ active: currentStep >= 4 || isDetailsView, 'inactive disabled': currentStep <= 3 && !isDetailsView }"
      id="upload"
      tabindex="0">
      <i
        class="icon-upload header-icon"
        [ngClass]="{ 'active-header-icon': currentStep >= 4 || isDetailsView }"
        (click)="navigate('documents')"></i>
      <div class="location-text-box">{{ 'app.navigation.doc_upload' | translate | uppercase }}</div>
    </li>

    <li
      *ngIf="showResultsPage"
      [ngClass]="{ active: currentStep >= 4 || isDetailsView, 'inactive disabled': currentStep <= 4 && !isDetailsView }"
      id="result"
      tabindex="0">
      <i
        class="pi pi-check header-icon"
        [ngClass]="{ 'active-header-icon': currentStep >= 4 || isDetailsView }"
        (click)="navigate('result')"></i>
      <div class="location-text-box">{{ 'app.navigation.results' | translate | uppercase }}</div>
    </li>
  </ul>
</div>
